import React from 'react';
import styles from "./App.module.scss"
// pages
import Quiz from "./pages/Quiz"
import GameOptions from "./pages/GameOptions"
import Home from "./pages/Home"
import About from "./pages/About"
// rrd
import { BrowserRouter, Routes, Route } from "react-router-dom";
// context
import { UsePopUp } from "./hooks/usePopUp"


const App: React.FC = () => {
  return (
    <div className={`${styles.App} back-img`}>
      <UsePopUp>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='start' element={<GameOptions />} />
            <Route path='quiz' element={<Quiz />} />
            <Route path='about' element={<About />} />
          </Routes>
        </BrowserRouter>
      </UsePopUp>
    </div>
  );
}

export default App;
